import { isEqual } from '@react-hookz/deep-equal';
import { useEffect } from 'react';
import { useCustomCompareEffect } from '../useCustomCompareEffect/index.js';
export function useDeepCompareEffect(callback, deps, effectHook = useEffect, ...effectHookRestArgs) {
    useCustomCompareEffect(callback, deps, isEqual, effectHook, ...effectHookRestArgs);
}
